const bonos = [
  {
    emoji: '🔥',
    title: 'Curso desde cero de Inteligencia Artificial',
    desc: 'Aprende a dominar las herramientas de IA desde cero. Desde prompts básicos hasta automatizaciones avanzadas para tu negocio.',
    value: 'Valor: S/ 97',
  },
  {
    emoji: '🔥',
    title: 'Plantillas Premium para Canva',
    desc: 'Pack de +500 plantillas profesionales para redes sociales, presentaciones, flyers y más. Diseño de agencia sin ser diseñador.',
    value: 'Valor: S/ 49',
  },
  {
    emoji: '🔥',
    title: 'Canva PRO por 1 año',
    desc: 'Acceso completo a Canva PRO con millones de recursos premium, eliminación de fondo, Brand Kit y herramientas de IA integradas.',
    value: 'Valor: S/ 120',
  },
];

export default function Bonos() {
  return (
    <section id="bonos" className="relative py-20 md:py-32 px-4 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1a0533] via-[#0d0d0d] to-[#0a1a0f]" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] md:w-[600px] md:h-[600px] rounded-full bg-[#8b5cf6]/8 blur-[100px]" />
        <div className="absolute bottom-0 right-0 w-[200px] h-[200px] rounded-full bg-[#10b981]/8 blur-[80px]" />
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'radial-gradient(circle, #8b5cf6 1px, transparent 1px)',
            backgroundSize: '32px 32px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto">
        {/* Outer frame */}
        <div
          className="rounded-[24px] md:rounded-[32px] p-[2px]"
          style={{ background: 'linear-gradient(135deg, #8b5cf6, #10b981, #ec4899)' }}
        >
          <div className="bg-[#0a0a0a]/95 rounded-[22px] md:rounded-[28px] px-4 sm:px-8 md:px-12 py-10 md:py-16">

            {/* Header */}
            <div className="text-center mb-10 md:mb-12">
              <div className="text-4xl md:text-5xl mb-4">🎁</div>
              <span className="inline-block bg-[#10b981]/10 border border-[#10b981]/40 text-[#10b981] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
                Solo si aprovechas AHORA
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white leading-tight">
                Y si aprovechas{' '}
                <span className="bg-gradient-to-r from-[#ec4899] to-[#8b5cf6] bg-clip-text text-transparent">
                  AHORA
                </span>
                , te llevas estos{' '}
                <span className="bg-gradient-to-r from-[#10b981] to-[#8b5cf6] bg-clip-text text-transparent">
                  BONOS EXCLUSIVOS
                </span>
              </h2>
            </div>

            {/* Bonos List */}
            <div className="space-y-4">
              {bonos.map((bono, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 md:gap-4 bg-[#111827]/80 border-l-4 border-[#10b981] rounded-2xl p-4 md:p-6 hover:translate-x-1 transition-transform duration-300 cursor-default"
                >
                  <span className="text-2xl md:text-3xl flex-shrink-0 mt-0.5">{bono.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 sm:gap-2 mb-2">
                      <h3 className="text-white font-black text-base md:text-xl leading-tight">{bono.title}</h3>
                      <span className="flex-shrink-0 self-start bg-[#10b981]/15 border border-[#10b981]/40 text-[#10b981] text-xs font-bold px-3 py-1 rounded-full">
                        {bono.value}
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed">{bono.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Total value */}
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 bg-[#1f2937]/60 border border-[#8b5cf6]/30 rounded-2xl px-5 md:px-6 py-4 md:py-5">
              <div className="text-center sm:text-left">
                <p className="text-gray-400 text-sm">Valor total de los bonos</p>
                <p className="text-white font-black text-xl md:text-2xl">S/ 266 en bonos</p>
              </div>
              <div className="text-center sm:text-right">
                <p className="text-gray-400 text-sm">Tú los recibes por</p>
                <p className="text-[#10b981] font-black text-xl md:text-2xl">¡GRATIS! 🎉</p>
              </div>
            </div>

            {/* Anchor text */}
            <div className="mt-8 md:mt-10 text-center">
              <div className="inline-block bg-[#0a0a0a] border border-[#8b5cf6]/40 rounded-full px-5 md:px-8 py-3 md:py-4">
                <p className="text-white font-bold text-base md:text-xl">
                  Todo el ecosistema de herramientas por el precio de una sola. 🚀
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
